(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-buy-now-button"] && !Shopify.designMode) return;
  try {
    class BuyNowButton extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.button = this.querySelector('button');
      if (this.button) this.button.addEventListener('click', () => this.buy());
      // Coming back from checkout with the Back button restores this page from the back/forward
      // cache with the button still in its loading state, so undo it
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.reset();
      });
    }

    reset() {
      if (!this.button || !this.button.classList.contains('is-loading')) return;
      this.button.removeAttribute('disabled');
      this.button.classList.remove('is-loading');
    }

    async buy() {
      if (!this.button || this.button.hasAttribute('disabled')) return;

      const form = this.closest('form');
      // Prefer the form's current variant id (the variant picker keeps [name="id"]
      // up to date on the product page); fall back to the initial variant on cards.
      const idInput = form && form.querySelector('[name="id"]');
      const id = parseInt((idInput && idInput.value) || this.dataset.variantId, 10);
      if (!id) return;

      // Respect the quantity stepper if present, default 1.
      let qty = 1;
      const qtyInput = form && form.querySelector('[name="quantity"]');
      if (qtyInput && parseInt(qtyInput.value, 10) > 0) qty = parseInt(qtyInput.value, 10);

      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      this.button.setAttribute('disabled', '');
      this.button.classList.add('is-loading');
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: qty }] }),
        });
        if (!res.ok) throw new Error('add-to-cart failed');
        window.location.href = root + 'checkout';
      } catch (e) {
        this.reset();
      }
    }
  }

  if (!customElements.get('buy-now-button')) {
    customElements.define('buy-now-button', BuyNowButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-rating"] && !Shopify.designMode) return;
  try {
    class HeaderRating extends HTMLElement {
    static CACHE_TTL = 24 * 60 * 60 * 1000;

    connectedCallback() {
      const { placeId, apiKey } = this.dataset;
      if (!placeId || !apiKey) return;

      const cacheKey = `header-rating:${placeId}`;
      const cached = this.#readCache(cacheKey);
      if (cached) {
        this.#show(cached);
        return;
      }

      fetch(`https://places.googleapis.com/v1/places/${encodeURIComponent(placeId)}`, {
        headers: { 'X-Goog-Api-Key': apiKey, 'X-Goog-FieldMask': 'rating' },
      })
        .then((response) => (response.ok ? response.json() : Promise.reject(response.status)))
        .then(({ rating }) => {
          if (!rating) return;
          this.#show(rating);
          try {
            localStorage.setItem(cacheKey, JSON.stringify({ rating, savedAt: Date.now() }));
          } catch {}
        })
        .catch((error) => console.warn('[header-rating] Could not load Google rating', error));
    }

    #readCache(key) {
      try {
        const { rating, savedAt } = JSON.parse(localStorage.getItem(key) || 'null') || {};
        return rating && Date.now() - savedAt < HeaderRating.CACHE_TTL ? rating : null;
      } catch {
        return null;
      }
    }

    #show(rating) {
      const value = this.querySelector('[ref="value"]');
      if (value) value.textContent = Number(rating).toFixed(1);
      this.hidden = false;
    }
  }

  if (!customElements.get('header-rating')) customElements.define('header-rating', HeaderRating);
  } catch(e) { console.error(e); }
})();

})();
